import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class ContactService {
  DoGetSuggestContactCode() {
    const _input: any = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetSuggestContactCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSearchedContactAddress(input: any) {
    const _input: any = {
      merchantId: 0,
      taxId: input.taxId,
      branchCode: input.branchCode,
    };

    return service.peakRealTimeAPIForImport
      .post("/api/Contact/GetSearchedContactAddress", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoCreateContact(contactTemplate: any, isAllowCreateContactDuplicate: boolean) {
    const _input: any = {
      merchantId: MerchantId(),
      contact: contactTemplate,
      isAllowCreateContactDuplicate: isAllowCreateContactDuplicate,
    };
    return service.peakRealTimeAPI.post("/api/Contact/CreateContactOnce", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetContactTable(input: any) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      tableContactView: {
        tableStatus: input.tableStatus,
        searchText: input.searchText,
        tableSorting: input.tableSorting,
        contactTableView: input.contactTableView,
        contactGroupId: input.contactGroupId,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };
    return service.peakExportAPI
      .post("/api/Table/GetContactTableForNewPeak", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetDefaultContactTemplateFromRd() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetDefaultContactTemplateFromRd", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSearchContactTemplateFromRd(searchText: string) {
    const _input = {
      merchantId: MerchantId(),
      searchText: searchText,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetSearchContactTemplateFromRd", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetContactPersonList(contactId: any) {
    const _input = {
      merchantId: MerchantId(),
      contactId: contactId,
      language: i18n.locale,
    };
    return service.peakRealTimeAPI.post("/api/Contact/GetContactPersonList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetContactDetailByid(contactId: any) {
    const _input = {
      merchantId: MerchantId(),
      contactId: contactId,
    };
    return service.peakRealTimeAPI.post("/api/Contact/GetContactDetailByid", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateIsArchivedContact(contact: any) {
    const _input = {
      merchantId: MerchantId(),
      isArchived: contact.isArchived,
      contactId: contact.contactId,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/UpdateIsArchivedContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetContactByContactIdList(contactIdList: Array<number>) {
    const _input = {
      merchantId: MerchantId(),
      contactIdList: contactIdList,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/Contact/GetContactByContactIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetFavoriteContactModelList(favoriteTypeId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        favoriteTypeId: favoriteTypeId,
      },
    };
    return service.peakTaxAPI
      .post("/api/Contact/GetFavoriteContactModelList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoDeleteFavoriteContact(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Contact/DeleteFavoriteContact", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoUpdateFavoriteContact(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Contact/InsertFavoriteContact", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoEditContact(contactDetail: Record<string, any>) {
    const _input = {
      merchantId: MerchantId(),
      contact: contactDetail,
    };
    return service.peakRealTimeAPI.post("/api/Contact/EditContact", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoValidateCanDeleteContact(contactId: string) {
    const _input = {
      merchantId: MerchantId(),
      contactId: contactId,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/ValidateCanDeleteContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetContactSearchFirst() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchFirst", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoDeleteContact(contactId: string) {
    const _input = {
      merchantId: MerchantId(),
      contactId: contactId,
    };

    return service.peakRealTimeAPI.post("/api/Contact/DeleteContact", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetContactSearchWithSearchText(searchText: string) {
    const _input = {
      merchantId: MerchantId(),
      searchText: searchText,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchWithSearchText", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new ContactService();
